import { sendGet, sendPost } from '@/utils/base'

export const getMoneyApi = data => sendGet('/api/splcloud/fcgi-bin/gethotkey.fcg', data)

export const postMoneyApi = data => sendPost('/api/fundClient/fundTarget/listCategory', data)

/**
 * @name 发送验证码
 * @api http://10.170.34.134:3000/project/104/interface/api/4012
 * @param { String } mobile 手机号
 * @param { String } action 行为（mobileLogin：手机号验证码登录）
 * @param { String } channelCode 渠道（3位一级），001：普泽
 */
export const postSendSms = (data = {}) => {
  return sendPost('/api/mam-service/account/sendSms', data)
}

/**
 * @name V0.2-核验渠道静默登录sessionCode并设置cookie
 * @api http://10.170.34.134:3000/project/104/interface/api/6170
 * @param { String } sessionCode sessionCode
 */
export const checkSessionCode = (data = {}) => {
  return sendPost('/api/mam-service/account/checkSessionCode', data)
}

/**
 * @name 登录或注册
 * @api http://10.170.34.134:3000/project/104/interface/api/4004
 * @param { String } mobile 手机号
 * @param { String } authCode 验证码
 * @param { String } action 行为（mobileLogin：手机号验证码登录）
 * @param { String } channelCode 渠道（3位一级），001：普泽
 */
export const postAccountLogin = (data) => {
  return sendPost('/api/mam-service/account/login', data)
}

/**
 * @name V0.2-手机号验证码登录
 * @api http://10.170.34.134:3000/project/104/interface/api/6009
 * @param { String } mobile 手机号
 * @param { String } authCode 验证码
 * @param { String } action 行为（mobileLogin：手机号验证码登录）
 * @param { String } channelCode 渠道（3位一级），001：普泽
 */
export const mobileAuthCodeLogin = (data) => {
  return sendPost('/api/mam-service/account/mobileAuthCodeLogin', data)
}

/**
 * @name 退出登录
 * @api http://10.170.34.134:3000/project/104/interface/api/4700
 */
export const postAccountLoginout = (data = {}) => {
  return sendPost('/api/mam-service/account/logout', data)
}

/**
 * @name 上传证件图片
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11220
 * @param { File } headImg 头像面图片
 * @param { File } nationalImg 国徽面图片
 */
export const foreignImage = (data = {}) => {
  return sendPost('/api/mam-service/account/foreignImage', data, { headers: { 'Content-Type': 'multipart/form-data' } })
}

/**
 * @name 上传外国人永居身份信息
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11221
 */
export const foreignInformation = (data = {}) => {
  return sendPost('/api/mam-service/account/foreignInformation', data)
}

/**
 * @name 身份证OCR
 * @param { File } headImg 头像面图片
 * @param { File } nationalImg 国徽面图片
 */
export const checkUploadOcr = (data = {}) => {
  return sendPost('/api/mam-service/account/checkUploadOcr', data, { headers: { 'Content-Type': 'multipart/form-data' } })
}

/**
 * @name 查询开户支持银行卡列表
 */
export const selectBankLimits = (data = {}) => {
  return sendPost('/api/mam-service/account/selectBankLimits', data)
}

/**
 * @name 银行卡发送验证码
 * @param { String } bankAccoName 客户名称
 * @param { String } bankAcco 银行卡号
 * @param { String } bankReserveMobile 银行卡预留手机号
 * @param { String } bankSerial 银行编码
 */
export const sendBankAuthCode = (data = {}) => {
  return sendPost('/api/mam-service/account/sendBankAuthCode', data)
}

/**
 * @name 银行卡鉴权验证验证码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/12149
 */
export const accountCheckBankAuthCode = (data = {}) => {
  return sendPost('/api/mam-service/account/checkBankAuthCode', data)
}

/**
 * @name 银行卡发送验证码
 * @param { String } bankAccoName 客户名称
 * @param { String } bankAcco 银行卡号
 * @param { String } bankReserveMobile 银行卡预留手机号
 * @param { String } bankSerial 银行编码
*/
export const sendBankAuthCodeInCheck = (data = {}) => {
  return sendPost('/api/mam-service/account/sendBankAuthCodeInCheck', data)
}

/**
 * @name 快付通 - 银行卡重新签约发送验证码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10985
 * @param { String } tradeAcco 交易账号
 * @param { String } mobile 银行卡预留手机号
*/
export const sendReQuickSignBankAuthCode = (data = {}) => {
  return sendPost('/api/mam-service/account/sendReQuickSignBankAuthCode', data)
}

/**
 * @name 银行卡鉴权通过后开户
 * @param { String } bankAccoName 客户名称
 * @param { String } bankAcco 银行卡号
 * @param { String } bankReserveMobile 银行卡预留手机号
 * @param { String } bankSerial 银行编码
 * @param { String } bankAuthCode 银行卡号验证码
 * @param { String } bankName 银行名称
 * @param { String } accoReqSerial 申请序列号
 */
export const checkBankInfo = (data = {}) => {
  return sendPost('/api/mam-service/account/checkBankAuthCodeAndOpenAccount', data)
}

/**
 * @name 银行卡鉴权并合并用户
 * @api http://10.170.34.134:3000/project/104/interface/api/9985
 * @param { String } bankAccoName 客户名称
 * @param { String } bankAcco 银行卡号
 * @param { String } bankReserveMobile 银行卡预留手机号
 * @param { String } bankSerial 银行编码
 * @param { String } bankAuthCode 银行卡号验证码
 * @param { String } bankName 银行名称
 * @param { String } accoReqSerial 申请序列号
 * @param { String } originalUser 待合并用户id
 */
export const checkBankAuthCodeAndMergeUser = (data = {}) => {
  return sendPost('/api/mam-service/account/checkBankAuthCodeAndMergeUser', data)
}

/**
 * @name 查询风险问卷题目
 */
export const queryRiskQuestions = (data = {}) => {
  return sendPost('/api/mam-service/account/queryRiskQuestions', data)
}

/**
 * @name V0.6-查询风测题目（私募）
 * 本期需求公私募风测题目一致，所以统一采用私募题目
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10998
 */
export const accountGetSMQuestionInfo = (data = {}) => {
  return sendPost('/api/mam-service/account/getSmQuestionInfo', data)
}

/**
 * @name 提交风险问卷答案
 * @param { Object } riskAnswers 风险问卷答案（{"题目号":"答案值"}）
 * @param { String } riskAnswers minRiskQuestioncont 最低风险答案
 */
export const submitRiskAnswers = (data = {}) => {
  return sendPost('/api/mam-service/account/submitRiskAnswers', data)
}

/**
 * @name V0.6-提交风测题目（私募
 * @param { Object } riskAnswers 风险问卷答案（{"题目号":"答案值"}）
 * @param { String } riskAnswers minRiskQuestioncont 最低风险答案
 */
export const submitSmRiskResult = (data = {}) => {
  return sendPost('/api/mam-service/account/submitSmRiskResult', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * @name V0.6-提交风测题目（私募
 * @param { Object } riskAnswers 风险问卷答案（{"题目号":"答案值"}）
 * @param { String } riskAnswers minRiskQuestioncont 最低风险答案
 */
export const accountSubmitResult = (data = {}) => {
  return sendPost('/api/mam-service/account/submitResult', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * @name V0.6-查询风测次数（私募）
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11000
 */
export const accountCheckSmRiskCount = (data = {}) => {
  return sendPost('/api/mam-service/account/checkSmRiskCount', data)
}

/**
 * @name 记录持仓产品和客户风险等级不一致的信息
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10997
 */
export const recordRiskMismatch = (data = {}) => {
  return sendPost('/api/mam-service/account/recordRiskMismatch', data)
}

/**
 * @name 我的信息-查询用户详情
 */
export const getCustomerDetail = (data = {}) => {
  return sendPost('/api/mam-service/account/getCustomerDetail', data, {
    unCheckLogin: true,
    showLoading: true
  })
}

export const getCustomerDetailCheckLogin = (data = {}) => {
  return sendPost('/api/mam-service/account/getCustomerDetail', data)
}

/**
 * @name 授权
 * @api http://10.170.34.134:3000/project/104/interface/api/5540
 */
export const getAccountAuthorization = (data = {}) => {
  return sendPost('/api/mam-service/account/authorization', data)
}

/**
 * @name 验证客户信息是否完整
 */
export const validateAccountComplete = (data = {}) => {
  return sendPost('/api/mam-service/account/validateAccountComplete', data)
}

/**
 * @name 提交用户补全信息
 * @param { String } workcode 职业（字典code=Work_Code）
 * @param { String } educational 教育程度（字典code= Educational_type）
 * @param { String } badintegrity 不良诚信记录（字典code=Bad_Integrity_Type）没有传空
 * @param { String } badintegritydesc 不良诚信说明
 * @param { String } custFundTimeLimit 客户投资期限（字典code=Cust_Fund_Time_Limit_Type）
 * @param { String } investmentVarieties 投资品种（字典code=Investment_Varieties_Type）
 * @param { String } preYieldFlag 期望收益（字典code=Pre_Yield_Flag_Type）
 * @param { String } communicationAddr 通讯地址（省+市+区+详细地址）
 * @param { String } oricustflag 税收居民身份(字典code=Oricust_Flag_Type)
 */
export const submitUpdateInfo = (data = {}) => {
  return sendPost('/api/mam-service/account/submitUpdateInfo', data)
}

/**
 * @name 查询省市区
 */
export const getAddrList = (data = {}) => {
  return sendPost('/api/blade-system/region/getAllMap', data)
}

/**
 * @name 查询全部国家或地区
 */
export const selectAllCountry = (data = {}) => {
  return sendPost('/api/mam-service/account/selectAllCountry', data)
}

/**
 * @name 提交CRS答案
 * @param { String } oricustflag 税收居民身份(0：仅为中国税收居民，1：仅为非居民，2：既是中国税收居民又是其他国家（地区）税收居民)
 * @param { String } bornnation 出生国家code
 * @param { String } currentworknation 现居国家code
 * @param { String } currentworkaddr 现居地址英文
 * @param { String } engname 英文姓
 * @param { String } englastname 英文名
 * @param { String } engbornnation 出生国家code=bornnation
 * @param { String } engcurrentworknation 现居国家code=currentworknation
 * @param { Object[] } taxinfo[0].notaxnoreason 纳税信息-是否有纳税人识别号
 * @param { Object[] } taxinfo[0].taxnation 纳税信息-纳税人国家或地区code
 * @param { Object[] } taxinfo[0].taxno 纳税信息-纳税人识别号
 * @param { String } engcurrentaddr 居住地址英文
 * @param { String } currentaddr 现居地址英文=currentworkaddr
 */
export const submitCrs = (data = {}) => {
  return sendPost('/api/mam-service/account/submitCrs', data)
}

/**
 * @name 业务字典查询
 * @api http://10.170.34.134:3000/project/104/interface/api/3465
 * @param { String } code
 */
export const fetchDictBizDictionary = (data = {}) => {
  return sendGet('/api/blade-system/dict-biz/dictionary', data, { showLoading: false })
}

/**
 * @name 查询基金列表页
 * @api http://10.170.34.134:3000/project/104/interface/api/4780
 * @param { String } fundType
 * @param { String } ascs year_inc
 * @param { String } descs year_inc
 * @param { Number } current 1
 * @param { Number } size 10
 */
export const fetchSingleProductFundList = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/fundList', data, { showLoading: false })
}

/**
 * @name 搜索基金
 * @api http://10.170.34.134:3000/project/104/interface/api/5124
 * @param { String } keyword
 * @param { Number } size
 */
export const fetchSingleProductSearch = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/search', data)
}

/**
 * @name 搜索基金和投顾策略_app端
 * @api http://10.170.34.134:3000/project/104/interface/api/11304
 * @param { String } keyword
 * @param { Number } size
 */
export const fetchSearchSingleAndStrategyh = (data = {}) => {
  return sendPost('/api/mam-service/strategyproduct/app/searchSingleAndStrategy', data)
}

/**
 * @name 查看基金详情
 * @param { String } fundCode 基金代码 示例：020007
 */
export const fundDetail = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/detail', data)
}

/**
 * @name 查看指定基金业绩走势
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchFundRatioCurve = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundRatioCurve', data)
}

/**
 * @name 基金单位净值曲线
 * @param { String } fundCode 基金代码 示例：020007
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6261
 */
export const searchFundNavUnitCurve = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundNavUnitCurve', data)
}

/**
 * @name 查看指定基金历史业绩
 * @param { String } fundCode 基金代码 示例：020007
 */
export const fundHistoricalPerformance = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/fundHistoricalPerformance', data)
}

/**
 * @name 查看指定基金历史净值（分页）
 * @param { String } fundCode 基金代码 示例：020007
 */
export const historyFundNavList = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/historyFundNavList', data, { showLoading: false })
}

/**
 * @name 查看指定基金经理列表
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchFundManagerList = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundManagerList', data)
}

/**
 * @name 基金档案-查看指定基金概况
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchFundDescription = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundDescription', data)
}

/**
 * @name 基金档案-查看指定基金行业
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchIndInfo = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchIndInfo', data)
}

/**
 * @name 基金档案-查看指定基金公告（分页）
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchFundAnnouncements = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundAnnouncements', data, { showLoading: false })
}

/**
 * @name 基金档案-查看指定基金重仓股
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchFundStockAndBond = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundStockAndBond', data)
}

/**
 * @name 基金档案-查看指定基金重仓明细，包含股票、债券和相关比例信息
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchFundStockAndBondDetail = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundPosition', data)
}

/**
 * @name 基金档案-查看指定基金分红送股
 * @param { String } fundCode 基金代码 示例：020007
 */
export const searchDividendSplitInfo = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchDividendSplitInfo', data)
}

/**
 * @name 基金交易规则费率
 * @param { String } fundCode 基金代码 示例：020007
 * @param { String } buySell 买：B 卖：S
 */
export const searchTradeFee = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchTradeFee', data)
}

/**
 * @name 购买基金前校验-产品详情页
 * @param { String } fundCode 基金代码 示例：020007
 * @param { String } buyTypeEnum 0 申购，1 认购
 */
export const buySingleFundCheckProductPage = (data = {}) => {
  return sendPost('/api/mam-service/trade/buySingleFundCheckProductPage', data)
}

/**
 * @name 申购或认购前校验接口-发送验证码
 * @param { String } tradeAcco 交易账号
 * @param { String } fundCode 基金编码
 * @param { String } applySum 申请金额
 * @param { String } buyTypeEnum 买入类型  申购 "0" 认购 "1" 一期只有申购
 * @param { String } buyPaymentEnum 支付方式  银行卡购买 "0" 超宝购买（活钱宝） "1" 汇款购买 "2" 一期没有汇款
 * @param { String } redeemChaobaoFundCode 超宝基金编码，buyPaymentEnum为1时，该字段不能为空
 * @param { String } ip id
 * @param { String } mac mac
 * @param { String } deviceId 设备id
 */
export const buySingleFundCheckProduct = (data = {}) => {
  return sendPost('/api/mam-service/trade/buySingleFundCheckProduct', data)
}
export const payChannelByLowestRateApi = (data = {}) => {
  return sendPost('/api/mam-service/trade/payChannelByLowestRate', data)
}
/**
 * @name 交易发送验证码
 * @param { String } action 申购单个基金 ("buySingleFund", "购买单个基金")
 * @param { String } action 赎回单个基金 ("redeemSingleFund", "赎回单个基金")
 * @param { String } action 申购超宝单个基金 ("purchaseChaoBaoSingleFund", "申购超宝单个基金")
 * @param { String } action 赎回超宝单个基金 ("redeemChaoBaoSingleFund", "赎回超宝单个基金"),
 * @param { String } action 赎回超宝单个基金 ("redeemNotSupportChaoBao", "赎回不支持的超宝基金"),
 */
export const sendSms = (data = {}) => {
  return sendPost('/api/mam-service/trade/sendSms', data)
}

/**
 * @name 购买普通基金接口
 * @param { String } tradeAcco 交易账号 - 选卡接口返回
 * @param { String } fundCode 基金编码
 * @param { String } applySum 交易金额
 * @param { String } mobile 绑定手机号
 * @param { String } verificationCode 验证码
 * @param { String } buyTypeEnum 0:申购 1:认购
 * @param { String } buyPaymentEnum 0:银行卡购买 1:超宝购买 2:汇款购买
 * @param { String } redeemChaobaoFundCode 超宝基金编码(非必传)
 * @param { String } ip ip地址(非必传)
 * @param { String } mac mac地址(非必传)
 * @param { String } deviceId 设备ID(非必传)
 */
export const buySingleFund = (data = {}) => {
  return sendPost('/api/mam-service/trade/buySingleFund', data, { showLoading: false })
}

/**
 * @name 付款方式列表
 * @param { String } fundCode 基金编号
 * http://10.170.34.134:3000/mock/104/api/v1/purchase/payways
 */
export const payways = (data = {}) => {
  return sendPost('/api/mam-service/api/v1/purchase/payways', data)
}

/**
 * @name 支付结果查询接口
 * @param { String } orderNo 订单号
 */
export const orderApplyResult = (data = {}) => {
  return sendPost('/api/mam-service/order/orderApplyResult', data, { showLoading: false })
}

/**
 * @name 3.16 银行卡-超宝-普通基金支付结果查询接口
 * @param { String } orderNo 订单号
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6107
 */
export const collectionOrderOrderApplyResult = (data = {}) => {
  return sendPost('/api/mam-service/collectionOrder/orderApplyResult', data, { showLoading: false })
}

/**
 * @name 赎回页面（可赎回资产信息
 * @param { String } fundCode 基金代码
 */
export const fundSellAvailable = (data = {}) => {
  return sendPost('/api/mam-service/api/v1/redeem/available', data)
}

/**
 * @name 赎回单只普通基金前校验接口 - 页面
 * @param { String } fundCode 基金代码
 */
export const redeemSingleFundCheckPage = (data = {}) => {
  return sendPost('/api/mam-service/trade/redeemSingleFundCheckPage', data)
}

/**
 * @name 赎回单只普通基金前校验 - 验证码
 * @param { String } fundCode 基金代码
 * @param { String } tradeAcco 交易账号
 * @param { String } applyShare 赎回份额
 * @param { String } verificationCode 验证码
 * @param { String } sellPaymentEnum SELL_BANK_PAYMENT("0", "回款到银行卡"), SELL_CHAOBAO_PAYMENT("1", "回款到超宝"),
 * @param { String } chaobaoFundCode 赎回到超宝基金代码
 */
export const redeemSingleFundCheck = (data = {}) => {
  return sendPost('/api/mam-service/trade/redeemSingleFundCheck', data)
}

/**
 * @name 赎回单只普通基金接口
 * @param { String } fundCode 基金代码
 * @param { String } tradeAcco 交易账号
 * @param { String } applyShare 赎回份额
 * @param { String } verificationCode 验证码
 * @param { String } sellPaymentEnum SELL_BANK_PAYMENT("0", "回款到银行卡"), SELL_CHAOBAO_PAYMENT("1", "回款到超宝"),
 * @param { String } chaobaoFundCode 赎回到超宝基金代码
 */
export const redeemSingleFund = (data = {}) => {
  return sendPost('/api/mam-service/trade/redeemSingleFund', data, { showLoading: false })
}

/**
 * @name 根据交易账号查询对应的银行卡信息
 * @param { String } tradeAcco 交易账号
 */
export const selectBankInfoByTradeAcco = (data = {}) => {
  return sendPost('/api/mam-service/account/selectBankInfoByTradeAcco', data)
}

/**
 * @name 银行卡重新签约发送验证码
 * @param { String } tradeAcco 交易账号
 */
export const sendReSignBankAuthCode = (data = {}) => {
  return sendPost('/api/mam-service/account/sendReSignBankAuthCode', data)
}

/**
 * @name 银行卡重新签约
 * @param { String } tradeAcco 交易账号
 * @param { String } accoReqSerial 申请序列号
 * @param { String } bankAuthCode 验证码
 */
export const reSignBankByTradeAcco = (data = {}) => {
  return sendPost('/api/mam-service/account/reSignBankByTradeAcco', data)
}

/**
 * @name V0.3-银行卡重新签约（快付通专用）
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5188
 * @param { String } tradeAcco 交易账号
 */
export const reQuickSignBankByTradeAcco = (data = {}) => {
  return sendPost('/api/mam-service/account/reQuickSignBankByTradeAcco', data)
}

/**
 * @name 卡bin查询接口
 * @param { String } cardNum 银行卡号
 */
export const selectCardBin = (data = {}) => {
  return sendPost('/api/mam-service/account/selectCardBin', data, { showLoading: false })
}

/**
 * @name 基金单品-基金协议
 * @param { String } fundCode 基金code
 */
export const singleProductFundAgreementList = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/fundAgreementList', data)
}

/**
 * @name c端接口-根据业务类型，查询协议名称
 * @param { String } businesstypelist 1,2,3,4
 */
export const protocolnamebybusinesstype = (data = {}) => {
  return sendPost('/api/mam-service/protocolmanage/protocolnamebybusinesstype', data)
}

/**
 * @name c端接口-根据业务类型列表，查询协议列表接口
 * @param { String } businesstypelist 1,2,3,4
 */
export const listbybusinesstype = (data = {}) => {
  return sendPost('/api/mam-service/protocolmanage/listbybusinesstype', data)
}

/**
 * @name c端接口-根据协议id，查询协议详情（包含协议富文本
 * @param { String } id
 */
export const protocolmanageDetailById = (data = {}) => {
  return sendPost('/api/mam-service/protocolmanage/detailById', data)
}

/**
 * @param { String } cardNum 银行卡号
 */
export const fundAgreementList = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/fundAgreementList', data)
}

/**
 * @name 根据渠道查询基础配置
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5729
 */
export const basicGetBasicConfig = (data = {}) => {
  return sendPost('/api/mam-service/basic/getBasicConfig', data, {
    showLoading: false
  })
}

/**
 * @name 查询滑块验证码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5792
 */
export const basicGetSlider = (data = {}) => {
  return sendPost('/api/mam-service/basic/getSlider', data)
}

/**
 * @name V0.2-核验滑块验证码通过后发送验证码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5869
 */
export const checkSliderAndSendAuth = (data = {}) => {
  return sendPost('/api/mam-service/basic/checkSliderAndSendAuth', data)
}

/**
 * @name V0.2-核验滑块验证码通过后发送验证码（已登录）
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6163
 */
export const checkSliderAndSendSms = (data = {}) => {
  return sendPost('/api/mam-service/account/checkSliderAndSendSms', data)
}

/**
 * @name V0.2-注册
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5876
 */
export const accountRegister = (data = {}) => {
  return sendPost('/api/mam-service/account/register', data)
}

/**
 * @name V0.2-设置登录密码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5883
 */
export const updateLoginPassword = (data = {}) => {
  return sendPost('/api/mam-service/account/updateLoginPassword', data)
}

/**
 * @name V0.2-忘记密码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6156
 */
export const forgetLoginPassword = (data = {}) => {
  return sendPost('/api/mam-service/account/forgetLoginPassword', data)
}

/**
 * @name V0.2-账号密码登录
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6149
 */
export const accountLogin = (data = {}) => {
  return sendPost('/api/mam-service/account/accountLogin', data)
}

/**
 * @name V0.2-设置交易密码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/5890
 */
export const updateTradePassword = (data = {}) => {
  return sendPost('/api/mam-service/account/updateTradePassword', data)
}

/**
 * @name 公告查询Toc
 * @param { String } displayRange 1-全局展示  2-我的TAB  3-基金持仓列表
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6247
 */
export const noticeGetInfo = (data = {}) => {
  return sendPost('/api/mam-service/api/v1/notice/getInfo', data, {
    unCheckLogin: true,
    showLoading: false
  })
}

/**
 * @name 点击已知晓托管
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6464
 */
export const migrateMarkAsKnown = (data = {}) => {
  return sendPost('/api/mam-service/migrate/markAsKnown', data)
}

/**
 * @name 开通汇款功能
 * @param { String } tradeAccount 交易账号
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6618
 */
export const accountOpenRemit = (data = {}) => {
  return sendPost('/api/mam-service/account/openRemit', data)
}

/**
 * @name 汇款购买信息页
 * @param { String } orderNo 订单号
 * @param { String } fundCode 基金编码
 * @wiki http://10.170.34.134:3000/project/104/interface/api/6632
 */
export const tradeRemitInfo = (data = {}) => {
  return sendPost('/api/mam-service/trade/remitInfo', data)
}

/**
 * @name 销户
 * @wiki http://10.170.34.134:3000/project/104/interface/api/8592
*/
export const accountCancel = (data = {}) => {
  return sendPost('/api/mam-service/account/cancel', data)
}

/**
 * @name 获取app最新版本
 * @wiki http://10.170.34.134:3000/project/104/interface/api/8151
*/
export const basicGetUpgradeVersionInfo = (data = {}) => {
  return sendPost('/api/mam-service/basic/getUpgradeVersionInfo', data)
}

/**
 * @name 用户银行卡列表(包含公募、私募)
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9439
*/
export const AccountBankCardList = (data = {}) => {
  return sendPost('/api/mam-service/account/bankCardList', data)
}

/**
 * @name V0.2-提交用户补全信息-账户实际受益人
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9894
*/
export const AccountAddBeneficiary = (data = {}) => {
  return sendPost('/api/mam-service/account/addBeneficiary', data)
}

/**
 * @name V0.2-提交用户补全信息-查询:账户受益所有人/实际控制
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10139
*/
export const AccountSelectAccountBeneficiaryOwner = (data = {}) => {
  return sendPost('/api/mam-service/account/selectAccountBeneficialOwner', data)
}

/**
 * @name V0.2-提交用户补全信息-修改:账户受益所有人/实际控制人
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10146
*/
export const AccountUpdateAccountBeneficiaryOwner = (data = {}) => {
  return sendPost('/api/mam-service/account/updateAccountBeneficialOwner', data)
}

/**
 * @name 查询客户详情
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9803
*/
export const ExchangeGetCustomerDetailCrypted = (data = {}) => {
  return sendPost('/api/mam-service/account/exchange/getCustomerDetail/crypted', data)
}

/**
 * @name 首页数据接口
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9544
*/
export const HomepageGetHomepageData = (data = {}) => {
  return sendGet('/api/mam-service/homepage/getHomepageData', data, {
    showLoading: false
  })
}

/**
 * @name 查询子区域产品列表
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9866
*/
export const getProductsByCondition = (data = {}) => {
  return sendGet('/api/mam-service/homepage/getProductsByCondition', data)
}

/**
 * @name id5身份认证
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9901
*/
export const IDAuth = (data = {}) => {
  return sendPost('/api/mam-service/account/id_auth', data)
}

/**
 * @name V0.4-邀请或分享链接注册
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9838
*/
export const AccountInviteRegister = (data = {}) => {
  return sendPost('/api/mam-service/account/inviteRegister', data)
}

/**
 * @name 查询公告详情
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10405
*/
export const NoticeNoticeDetail = (data = {}) => {
  return sendPost('/api/mam-notice/api/v2/notice/noticeDetail', data)
}

/**
 * @name 7.1 适当性回访
 * @wiki http://10.170.34.134:3000/project/104/interface/api/9936
*/
export const AproproatenessSave = (data = {}) => {
  return sendPost('/api/mam-service/aproproateness/save', data)
}

/**
 * @name 单品基金详情_copy
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11151
*/
export const SimpleFundDescription = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/simpleFundDescription', data)
}

/**
 * @name 对话接口(stream)
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11164
*/
export const AicsChatStream = (data = '') => {
  return new EventSource(`/api/mam-service/aics/chat/stream?query=${data}`)
}

/**
 * @name 智能客服-点赞、踩
*/
export const aicsLike = (data = {}) => {
  return sendPost('/api/mam-service/aics/like', data)
}

/**
 * @name 校验银行卡是否可注销
 * @wiki @yuanyuanmeng1
*/
export const AccountCheckUnBindBank = (data = {}) => {
  return sendPost('/api/mam-service/account/checkUnBindBank', data)
}

/**
 * @name 注销银行卡
 * @wiki @yuanyuanmeng1
*/
export const AccountUnBindBank = (data = {}) => {
  return sendPost('/api/mam-service/account/unBindBank', data)
}
// 基金详情-基金业绩分析指标【波动率】、【夏普比率】
export const performanceAnalysisIndicators = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/performanceAnalysisIndicators', data)
}

// 基金详情-盈利概率、平均收益
export const productAverageRate = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/productAverageRate', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11214
 * @name 基金转换页面-搜索基金
*/
export const singleProductChangeProductSearch = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/changeProduct/search', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11215
 * @name 基金转换页面-基金列表
*/
export const singleProductChangeProductList = (data = {}) => {
  return sendPost('/api/mam-service/api/v1/asset/changeProduct/list', data)
}
// 3.17赎回页面-基金转换-可转换份额及限额校验
export const getLimitAmount = (data = {}) => {
  return sendPost('/api/mam-service/trade/channge/getLimitAmount', data)
}

// 白名单
export const getWhiteListFlag = (data = {}) => {
  return sendPost('/api/mam-service/trade/getWhiteListFlag', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11231
 * @name 年度报告-持仓列表
*/
export const yearHoldShareReport = (data = {}) => {
  return sendPost('/api/mam-service/beta/asset/yearHoldShareReport', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11251
 * @name 查询客户银行卡已签约的支付渠道
*/
export const accountSelectCustomerPayChannel = (data = {}) => {
  return sendPost('/api/mam-service//account/selectCustomerPayChannel', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11244
 * @name 开通支付通道-发送验证码
*/
export const accountSendPayContractAuthCode = (data = {}) => {
  return sendPost('/api/mam-service/account/sendPayContractAuthCode', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11245
 * @name 开通支付通道-核验验证码
*/
export const accountCheckPayContractAuthCode = (data = {}) => {
  return sendPost('/api/mam-service/account/checkPayContractAuthCode', data)
}

export const assetPercentage = (data = {}) => {
  return sendPost('/api/mam-service/account/assetPercentage', data)
}

export const totalMigrateAsset = (data = {}) => {
  return sendPost('/api/mam-service/migrate/totalMigrateAsset', data)
}

export const searchFundAnnouncementsById = (data = {}) => {
  return sendPost('/api/mam-service/singleProduct/searchFundAnnouncementsById', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11286
 * @name 添加自选
*/
export const chooseFundAddChooseFund = (data = {}) => {
  return sendPost('/api/mam-service/chooseFund/addChooseFund', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11293
 * @name 删除自选
*/
export const chooseFundDeleteChooseFund = (data = {}) => {
  return sendPost('/api/mam-service/chooseFund/deleteChooseFund', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getRemitBank = () => {
  return sendGet('/api/blade-system/dict-biz/dictionary?code=remit_bank_serial', {},
    {
      showLoading: false
    }
  )
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11329
 * @name 7.2 查询用户的待确认风测
*/
export const accountGetNoConfirmRisk = (data = {}) => {
  return sendPost('/api/mam-service/account/getNoConfirmRisk', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11330
 * @name 7.2 风险结果确认
*/
export const accountRiskConfirm = (data = {}) => {
  return sendPost('/api/mam-service/account/riskConfirm', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11331
 * @name 7.2 根据风测等级获取错配产品
*/
export const accountGetRiskMisMatchFunds = (data = {}) => {
  return sendPost('/api/mam-service/account/getRiskMisMatchFunds', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/11365
 * @name 【官网公告】查询公告列表
*/
export const noticeOfficialWebNoticeInfoList = (data = {}) => {
  return sendPost('/api/mam-service/api/v1/notice/officialWeb/noticeInfoList', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/10405
 * @name 【官网公告】查询公告详情
*/
export const noticeOfficialWebNoticeDetail = (data = {}) => {
  return sendPost('/api/mam-service/api/v1/notice/officialWeb/noticeDetail', data)
}
/**
 * @name 搜索基金,热搜相关接口
 * @api http://10.170.34.134:3000/project/104/interface/api/cat_1778
 */
export const hotSerachList = (data = {}) => {
  return sendGet('/api/mam-service/search/hot/funds', data)
}
export const hotSearchAddItem = (data = {}) => {
  return sendPost('/api/mam-service/search/hot/report', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 微信授权绑定用户
export const getWechatAuth = data => sendGet('/api/mam-service/wechat/auth-url', data)

// 季度报告
export const quarterReportInfo = (data = {}) => {
  return sendGet('/api/mam-service/fund/announce/info', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 季度报告:季报列表
export const quarterReportList = (data = {}) => {
  return sendGet('/api/mam-service/fund/announce/list', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 季度报告:季报列表
export const detailQuarterReport = (data = {}) => {
  return sendGet('/api/mam-service/fund/announce/prompt', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/12128
 * @name 查询银行卡是否有在途订单
*/
export const accountIsBankAccountHasOnWayAsset = (data = {}) => {
  return sendPost('/api/mam-service/account/isBankAccountHasOnWayAsset', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/12135
 * @name 查询银行卡持仓资产是否超过阈值
*/
export const accountIsBankAccountAssetOver = (data = {}) => {
  return sendPost('/api/mam-service/account/isBankAccountAssetOver', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/12156
 * @name 上传换卡文件
*/
export const accountChangeBankCardUploadFile = (data = {}) => {
  return sendPost('/api/mam-service/account/changeBankCard/uploadFile', data, { headers: { 'Content-Type': 'multipart/form-data' } })
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/12163
 * @name 用户换卡申请
*/
export const accountChangeBankCardApply = (data = {}) => {
  return sendPost('/api/mam-service/account/changeBankCardApply', data)
}

/**
 * @wiki http://10.170.34.134:3000/project/104/interface/api/12170
 * @name 上一次失败申请
*/
export const accountLastFailApply = (data = {}) => {
  return sendPost('/api/mam-service/account/lastFailApply', data)
}

/**
 * @name 校验银行卡是否已绑定
*/
export const accountValidateChangeBankCard = (data = {}) => {
  return sendPost('/api/mam-service/account/validateChangeBankCard', data)
}

/**
 * @name 校验银行卡是否换卡
*/
export const accountIsBankAccountChangingEncrypt = (data = {}) => {
  return sendPost('/api/mam-service//account/isBankAccountChangingEncrypt', data)
}
/**
 * @name 解约后站内信通知用户，增加跳转验证接口
*/
export const singlePayWithoutContract = (data = {}) => {
  return sendPost('/api/mam-service/account/singlePayWithoutContract', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
/**
 * @name 查询热点动态或市场情报信息
*/
export const dynamicNoticeApi = (id) => {
  return sendGet(`/api/mam-service/dynamicNotice/detail/${id}`, {
  })
}
